export interface Constants {
    userReplayCollection: string;
};

export const constants = {
    userReplayCollection: 'replaysForAnalysis'
} as Constants;